import {NgModule} from "@angular/core";
import {ScheduledCallbacksComponent} from "./scheduled-callbacks.component";
import {ModalModule, TimepickerModule, DatepickerModule} from "ng2-bootstrap";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ControlMessagesModule} from "../../components/validation/control-messages.module";
import {CommonModule} from "@angular/common";

@NgModule({
    declarations: [ScheduledCallbacksComponent],
    imports: [
        TimepickerModule.forRoot(),
        DatepickerModule.forRoot(),
        ModalModule,
        CommonModule,
        ReactiveFormsModule,
        ControlMessagesModule,
        FormsModule
    ],
    exports: [ScheduledCallbacksComponent],
})

export class ScheduledCallbacksModule {
}


// WEBPACK FOOTER //
// ./src/app/modules/scheduled-callbacks/scheduled-callbacks.module.ts